import * as React from 'react';
import { Box } from '@mui/material';
import {
    DataGrid,
} from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';

export default function FullFeaturedCrudGrid({ rows, columns, showTool, hideFoot, hideFootPag, hideFootRowCount }) {
    return (
        <Box
            sx={{
                width: '100%',
                '& .actions': {
                    color: 'text.secondary',
                },
                '& .textPrimary': {
                    color: 'text.primary',
                },
                '@media print': {
                    '@page': {
                        size: 'landscape', // Fuerza la orientaci�n horizontal
                    },
                    '& .MuiDataGrid-footerContainer': {
                        display: 'none', // Oculta el footer al imprimir
                    },
                    '& .MuiDataGrid-main': {
                        height: 'auto', // Fuerza altura autom�tica en la impresi�n
                    },
                },
            }}
        >
            <DataGrid
                rows={rows}
                getRowId={(row) => row.id}
                columns={columns}
                autoHeight 
                disableVirtualization
                showToolbar={showTool}
                hideFooter={hideFoot}
                hideFooterPagination={hideFootPag}
                hideFooterSelectedRowCount={hideFootRowCount}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                slotProps={{
                    printOptions: {
                        hideFooter: true, // Oculta el footer al imprimir
                        hideToolbar: true,
                    },
                }}
            />
        </Box>
    );
}